import type { IconData } from '@stacksjs/iconify-core'

export const circleClock: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3 24a21 21 0 1 0 42 0a21 21 0 1 0-42 0\"/><path d=\"M9 24a15 15 0 1 0 30 0a15 15 0 1 0-30 0\"/><path d=\"M24 15v9l6 6\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default circleClock
